import Vue from 'vue';
//addClass
function addClass(el, className) {
    let classNameArr = el.className.split(' ');
    classNameArr.push(className);
    el.className = [...new Set(classNameArr)].join(' ');
}
//deleteClass
function deleteClass(el, className) {
    let classNameArr = el.className.split(' ');
    el.className = classNameArr.filter(item => {
        return item !== className
    }).join(' ');
}

//根据类型给出相应的判断函数
function typeFunc(type, bindingObj = {}) {
    if (type === 'number') {
        return function () {
            let value = this.value;
            if (value <= 0) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = bindingObj.prop + '不可小于等于零';
            } else if (value === '' || value === undefined || value === null) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = bindingObj.prop + '不可为空';
            } else {
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            };
        };
    } else if (type === 'string') {
        return function () {
            let value = this.value;
            if (value === '' || value === undefined || value === null) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = bindingObj.prop + '不可为空';
            } else {
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            };
        };
    } else if (type === 'phone') {
        return function () {
            let value = this.value;
            let reg = /^[0-9]+\-{0,1}[0-9]+$/;
            if (!reg.test(value) || value.length < 8 || value.length > 15) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = '请输入正确的电话号码，长度8-12位的数字';
            } else {
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            };
        };
    } else if (type === 'email') {
        return function () {
            let value = this.value;
            let reg = /^([a-zA-Z0-9])+([\.|a-zA-Z0-9_\-])+@([a-zA-Z0-9])+(.[a-zA-Z0-9])+/;
            if (!reg.test(value)) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = '请输入正确的邮箱';
            } else {
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            };
        };
    } else if (type === 'bankAccount') {
        return function () {
            let value = this.value;
            if (value.length < 16 || value.length > 19) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = bindingObj.prop + '长度为16-19位的数字';
            } else {
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            };
        };
    } else if (type === 'password') {
        return function () {
            let value = this.value;
            let reg = /^[0-9a-zA-Z]{6,12}$/g;
            if (!reg.test(value)) {
                addClass(this, 'light-input');
                bindingObj.onoff = true;
                bindingObj.note = bindingObj.prop + '长度为6-12位的数字或英文字符';
            }else{
                deleteClass(this, 'light-input');
                bindingObj.onoff = false;
            }
        };
    }
}

//增加校验指令
Vue.directive('verify', {
    bind:function (el, binding) {
        let input;
        if (el.nodeName !== 'INPUT') {
            input = el.querySelector('input');
        } else {
            input = el;
        };
        let obj = binding.value;
        if(!obj){
            return ;
        };
        if(obj.onoff){
            obj.note = obj.prop + '不可为空';
        }
        if (input) {
            input.addEventListener('blur', typeFunc(binding.value.type, obj), false);
        }
    }
});



// WEBPACK FOOTER //
// ./src/verify.js